import styled, { css } from 'styled-components';

export const LogosLine = styled.div`
  align-items: center;
  display: flex;
  width: fit-content;
  flex-wrap: nowrap;
  margin-bottom: 32px;
  opacity: 0;
  row-gap: 10px;
  transition: opacity 0.15s ease-in-out;

  &.isVisible {
    opacity: 1;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    margin-bottom: 24px;
    justify-content: center;
  }

  &.asSection {
    margin-bottom: 0;

    @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
      margin-bottom: 0;
    }
  }

  &.centered {
    justify-content: center;
    justify-self: center;
  }

  &.withBackground {
    height: 72px;
    background-color: white;
    border-radius: 130px;
    box-shadow: 14.62px 29.24px 58.49px 0 #8989891f, 25.99px 51.99px 109.96px 0 #63696f1f,
      4.87px 4.87px 10.56px 0 #ffffff33 inset;
    padding: 0 32px;

    & .client-logo img {
      max-height: 48px !important;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
      height: auto;
      padding: 8px 16px;
    }
  }

  &.headerContent {
    padding-bottom: 12px;
  }

  &.platform {
    padding: 80px 0 40px 0;

    @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
      padding-top: 64px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
      padding-top: 40px;
    }
  }

  &.noPadding {
    padding: 0;
    margin-bottom: 0 !important;
  }
`;

export const Logo = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  & .logo-box {
    width: fit-content;
  }

  img {
    display: block;
    max-height: 100%;
    align-self: center;
    max-width: 100%;
    object-fit: contain;
    width: auto;
  }

  &.client-logo {
    max-width: 205px;
    max-height: 64px;

    ${({ $customHeight }) =>
      $customHeight &&
      css`
        max-height: ${(props) => props.$customHeight}px !important;
      `};

    @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
      max-width: 128px;
      max-height: 40px;
    }
  }

  &.sword-logo {
    max-height: 24px;
    max-width: 100px;

    @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
      max-height: 20px;
      max-width: 81px;
    }
  }

  &.sub-brand-logo {
    max-height: 28px;
    max-width: 100px;

    ${({ $customMaxHeight }) =>
      $customMaxHeight &&
      css`
        max-height: ${(props) => props.$customMaxHeight}px !important;
      `};

    @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
      max-height: 20px;
      max-width: 81px;
    }
  }
`;

export const SplitBar = styled.div`
  height: 32px;
  width: 1px;
  background: ${(props) => props.theme.colors.grey.light};
  margin-left: 20px;
  margin-right: 20px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    margin-left: 10px;
    margin-right: 10px;
  }
`;
